import { useUserStore } from "@/store/user.js";
// Check if user is authorized to access a page or not
// User must have provided groups
// if not redirect to home page
export const isInGroupsMiddlewarePermission = (groups) => (to, from, next) => {
  const userStore = useUserStore();
  if (userStore.isDevOrSuperUser) {
    return next();
  }
  const isInGroups = groups.every((group) => userStore.isUserInGroup(group));
  if (!isInGroups || groups.length === 0) {
    return next("/");
  }
  return next();
};

export default isInGroupsMiddlewarePermission;
